import SubmissionCategoriesService from '@/services/submissionCategories';

export default {
	namespaced: true,
	state: {
	},

	getters: {
    
	},

	actions: {
		async getSubmissionCategories({commit, state, getters, dispatch}){
			try{
				const response = await SubmissionCategoriesService.getSubmissionCategories();
				return response
			}catch(e){
				console.log(e)
			}
		},		
		async createSubmissionCategories({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await SubmissionCategoriesService.createSubmissionCategories({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async updateSubmissionCategories({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await SubmissionCategoriesService.updateSubmissionCategories(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async deleteSubmissionCategories({ commit, state, getters, dispatch }, id) {
			let response;
			try {
				response = await SubmissionCategoriesService.deleteSubmissionCategories(id);
			} catch (e) {
				console.log(e);
			}
			return response
		}
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
